import { render, staticRenderFns } from "./ModalViewIdentityCard.vue?vue&type=template&id=00faf1b4&scoped=true"
import script from "./ModalViewIdentityCard.vue?vue&type=script&lang=js"
export * from "./ModalViewIdentityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00faf1b4",
  null
  
)

export default component.exports